<template>
  <div class="video-instructions inverse-scheme tv tv-list">
    <div class="tv-cell tv-cell-default caption-type">
      <base-icon name="pause_circled_ios" />
      <span>{{ __('You can pause and resume recording any number of times.') }}</span>
    </div>
    <div class="tv-cell tv-cell-default caption-type">
      <base-icon name="watch_ios" />
      <span>{{ timeLimitText }}</span>
    </div>
    <div class="tv-cell tv-cell-default caption-type">
      <base-icon name="play_circled_ios" />
      <span>{{ __('You can replay the video before you save.') }}</span>
    </div>
    <div class="tv-cell tv-cell-default caption-type">
      <base-icon name="laughing_ios" />
      <span>{{ __('You have a beautiful smile.') }}</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
export default {
  components: { BaseIcon },
  computed: {
    timeLimitText() {
      const translatedLimit = this.__('%{num} minutes', { num: '5' })
      return this.__('Your recordings can be up to %{timeLimit} long.', { timeLimit: translatedLimit })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
.video-instructions {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-image: linear-gradient(135deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
}
.tv-cell {
  font-size: $small-font-size;
  min-height: unset;
  padding: 2px 16px;
}
i {
  font-size: 18px;
}
</style>
